exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-8ce0e656]{position:absolute;right:0;left:0;bottom:0}.links[data-v-8ce0e656]:hover{color:#016145}.chat[data-v-8ce0e656]{color:#016145;cursor:pointer}.currency-wrapper[data-v-8ce0e656]{display:flex;align-items:center}.divider[data-v-8ce0e656]{height:21px;border-right:1px solid #f9a73c;margin-right:27px;margin-left:27px;width:1px}.tab-currency-wrapper[data-v-8ce0e656]{display:none}@media only screen and (max-width:959px){.tab-currency-wrapper[data-v-8ce0e656]{margin-bottom:40px;text-align:center;margin-top:15px;display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ce0e656","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/footer/Ffooter.vue
// module id = 505
// module chunks = 187